import { createAsyncThunk } from '@reduxjs/toolkit';
import { apiFetch } from '../../../utilities/appFetch';
import alarmSequenceRoutes from '../../../components/alarmSequence/alarmSequenceRoutes';

const update = createAsyncThunk(
  'thunk/alarmSequence/read',
  async (arg, thunkAPI) => {
    const response = await apiFetch(alarmSequenceRoutes.api.generate.read(arg?.id), {
      method: 'GET',
    });
    if (!response?.success) {
      return thunkAPI.rejectWithValue(response);
    }
    return response.result;
  },
);

export default update;
